import AppStore from "./AppStore";

const MissingPreset = () => null;
const reported = new Set<string>();

export function buildClassName(...args: any[]) {
  const className = args.filter((arg) => !!arg).join(" ");
  if (className === "") {
    return undefined;
  }
  return className;
}

export function lookupPreset(name: string) {
  const preset = AppStore.presets?.[name];
  if (preset) {
    return preset;
  }
  report(
    AppStore.presets
      ? `GroupFlow website preset not found: ${name}`
      : `GroupFlow website not initialized; cannot render preset ${name}`
  );
  return MissingPreset;
}

function report(message: string) {
  if (reported.has(message)) {
    return;
  }
  reported.add(message);
  console.error(message);
}
